import { type RefObject, type ReactNode } from 'react';

import { ResponsiveNavigationLayoutWrapper } from './ResponsiveNavigationLayoutWrapper';

export type ResponsiveNavigationLayoutProps = {
  children: ReactNode;
  button: ReactNode;
  hamburgerShouldBeMounted: boolean;
  hamburgerClassNames: string;
  isLevel2Visible?: boolean;
  ref: RefObject<HTMLElement | null>;
};

export const ResponsiveNavigationLayout = ({
  children,
  button,
  hamburgerClassNames,
  hamburgerShouldBeMounted,
  isLevel2Visible,
  ref,
}: ResponsiveNavigationLayoutProps) => (
  <ResponsiveNavigationLayoutWrapper
    isLevel2Visible={isLevel2Visible}
    hamburgerShouldBeMounted={hamburgerShouldBeMounted}
    button={button}
    ref={ref}
  >
    <div
      className={`${!hamburgerShouldBeMounted && 'max-lg:hidden max-lg:-translate-x-full'} ${hamburgerClassNames} max-lg:z-drawer max-lg:bg-color-background-base grid [grid-template:'header'_auto_'toggle'_auto_'content'_1fr_'anchor'_0px_/100%] max-lg:fixed max-lg:inset-0 max-lg:overflow-y-auto max-lg:shadow lg:relative max-lg:[&.transition-enter-active]:[transition:transform_ease-in-out_0.3s,opacity_ease-in-out_0.2s] motion-reduce:max-lg:[&.transition-enter-active]:transition-none max-lg:[&.transition-enter-from]:-translate-x-full max-lg:[&.transition-enter-from]:opacity-0 max-lg:[&.transition-leave-active]:[transition:transform_ease-in-out_0.3s,opacity_ease-in-out_0.2s] motion-reduce:max-lg:[&.transition-leave-active]:transition-none max-lg:[&.transition-leave-to]:-translate-x-full max-lg:[&.transition-leave-to]:opacity-0`}
    >
      {children}
    </div>
  </ResponsiveNavigationLayoutWrapper>
);
